import { IContext } from "@src/context";
import { IProperty } from "./types";
import fetchPropertiesJson from "../SearchResult/propertiesFetcher/allProperties";
import { getFavoriteList } from "@src/utils/favorite";

export function fetchFavoritedProperties(
  context: IContext
): Promise<IProperty[]> {
  const favoriteList = getFavoriteList();

  return Promise.all([fetchPropertiesJson(context)]).then(
    ([originProperties]) => {
      const favoritedProperties = originProperties.filter((property) => {
        if (property && property.id) {
          return favoriteList.includes(property.id.toString());
        }
      });

      return favoritedProperties;
    }
  );
}
